import React, { useState, useEffect } from "react";
import pagestyles from "../evolve-framework/pages/pages.module.css";
import axios from "axios";
import apiurl from "../apiUrl";

function VideoForm({ pageId, setShowVideoform }) {
    const [videoData, setVideoData] = useState({ videopath: '', pageid: pageId, headline:'',content:'' });
    const [pageHasVideo, setPageHasVideo] = useState(false);

    const fetchurl = apiurl + "getvideobypageid.php";
    const savefetchurl = apiurl + "savepagevideo.php";
    const updatefetchurl = apiurl + "updatepagevideo.php";

    useEffect(() => {
        const getData = async () => {
            try {
                const response = await axios.post(fetchurl, { pageId }, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    const elementslength = response.data.length;
                    if (elementslength > 0) {


                        setPageHasVideo(true);
                        setVideoData({pageid:pageId,videopath: response.data[0].pvi_path, headline: response.data[0].pvi_headline, content: response.data[0].pvi_content } );

                        console.log(response.data);
                    } else {
                        setPageHasVideo(false);
                    }
                }
            } catch (error) {
                console.error("Fehler", error);
            }
        };
        getData();
    }, [pageId]);

    const handleVideo = async () => {
        try {
            const response = await axios.post(savefetchurl, videoData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                console.log(response.data);
            } else {
                console.error('Fehler bei der Anfrage:', response.status);
            }
        } catch (error) {
            console.error('Fehler beim Senden der Daten:', error);
        }
        setShowVideoform(false);
    };

    const handleUpVideo = async () => {
        try {
            const response = await axios.post(updatefetchurl, videoData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.status === 200) {
                console.log(response.data);
            } else {
                console.error('Fehler bei der Anfrage:', response.status);
            }
        } catch (error) {
            console.error('Fehler beim Senden der Daten:', error);
        }
        setShowVideoform(false);
    };

    return (
        <section className={pagestyles.videoform}>

            <section className={pagestyles.closebutton} onClick={()=>setShowVideoform(false)}>X</section>
            <h5>Video hinzufügen</h5>

            {pageHasVideo ? (
                <section className="mio-form-field">
                    <label>Pfad zum Video</label>
                    <input
                        type="text"
                        value={videoData.videopath}
                        onChange={(e) => setVideoData({ ...videoData, videopath: e.target.value })}
                    />

                    <label>Headline</label>
                    <input
                        type="text"
                        value={videoData.headline}
                        onChange={(e) => setVideoData({ ...videoData, headline: e.target.value })}

                    />

                    <label>Content</label>
                    <textarea
                        value={videoData.content}
                        onChange={(e) => setVideoData({ ...videoData, content: e.target.value })}
                    >{videoData.content}</textarea>

                    <buttom className={"cta-button"} onClick={handleUpVideo}>Videodaten speichern</buttom>

                </section>
            ) : (
                <section className="mio-form-field tab-flex-4 flex-12">
                    <input
                        type="text"
                        value={videoData.videopath}
                        onChange={(e) => setVideoData({ ...videoData, videopath: e.target.value })}

                    />

                    <label>Headline</label>
                    <input
                        type="text"
                        value={videoData.headline}
                        onChange={(e) => setVideoData({ ...videoData, headline: e.target.value })}

                    />

                    <label>Content</label>
                    <textarea
                        value={videoData.content}
                        onChange={(e) => setVideoData({ ...videoData, content: e.target.value })}
                    >{videoData.content}</textarea>

                    <buttom className={"cta-button"} onclick={handleVideo}>Videodaten speichern</buttom>


                </section>
            )}
        </section>
    );
}

export default VideoForm;
